<template>
  <div>
    <b-card no-body class="mb-3">
      <b-card-header>
        <b-container fluid class="px-0">
          <b-row class="align-items-center">
            <b-col class="mb-3 mb-md-0" cols="12" offset-md="4" md="4">
              <div class="h5 mb-0 w-100 font-weight-bold">
                <b-button-group class="w-100">
                  <b-button
                    class="px-5"
                    :class="edibleType === 'Food' ? 'activeBtn' : 'deactiveBtn' "
                    @click="changeMenuType('Food')"
                  >Food</b-button>
                  <b-button
                    class="px-5"
                    :class="edibleType === 'Drink' ? 'activeBtn' : 'deactiveBtn' "
                    @click="changeMenuType('Drink')"
                  >Drink</b-button>
                </b-button-group>
              </div>
            </b-col>
            <b-col cols="12" md="4" class="text-right">
              <b-btn variant="danger" size="sm">
                <span @click="createModal = true">
                    MENU TYPE +
                </span>
              </b-btn>
            </b-col>
          </b-row>
        </b-container>

      </b-card-header>
      <b-overlay :show="progressing" rounded="sm">
        <div v-if="items.length" class="overflow-auto">
          <ul class="list-style-none menutypes bg-white p-0 mb-0 d-flex">
            <li style="min-width: 160px" class="d-inline-block position-relative menu-type py-2 px-3 d-flex align-content-center justify-content-center flex-column"
                :class="[
                    {
                        // 'active-menu-type': item.selected,
                        'special-menu-type': item.IsSpecial,
                        'invisible-menu-type': !item.IsVisible
                    }]
                "
                @click="selectMenuType(item)"
                v-for="(item, index) in items"
                :key="`menuType${index}`"
            >
              <div v-if="item.selected"
                   class="position-absolute w-100 h-100 active-menu-type"
                   style="right: 0;top: 0; z-index: 1"></div>
              <div class="position-relative" style="z-index: 2">
                <div>
                  <span :class="item.selected ? 'font-weight-bold' : ''">
                    {{item.MenuType}}
                  </span>
                  <span class="small" v-if="!item.IsVisible">(Hidden)</span>
                  <span @click="getSelectedMenuType(item)" class="small ml-2 cursor-pointer" v-if="item.selected && item.MenuTypeID">
                      (Edit)
                  </span>
                </div>
                <template v-if="!item.IsTimeBased && profile.RestaurantWorkingHoursToday.length && !item.IsSpecial">
                  <div>
                    <span class="small">
                      <span v-if="profile.RestaurantWorkingHoursToday[0].StartTime === 'CLOSED' || profile.RestaurantWorkingHoursToday[0].EndTime === 'CLOSED'">
                        Unavailable Today
                      </span>
                      <span v-else v-for="(day,index) in profile.RestaurantWorkingHoursToday">

                        <span v-if="day.StartTime"
                          >{{day.StartTime}}
                        </span>
                        <span v-if="day.EndTime">
                          {{' - ' + day.EndTime}}
                        </span>
                        <br>
                    </span>
                  </span>
                  </div>
                </template>
                <template v-else>
                  <template v-if="item.IsSpecial">
                    <span class="small" v-if="item.StartDate !== item.EndDate">
                        {{specialDate(item.StartDate)}} - {{specialDate(item.EndDate)}}
                    </span>
                    <span class="small" v-else>
                      {{specialDate(item.StartDate)}}
                    </span>
                  </template>
                  <template v-else>
                    <div v-if="item.RestaurantMenuTypeHoursToday && item.RestaurantMenuTypeHoursToday.length">
                      <span class="small">
                        {{item.RestaurantMenuTypeHoursToday[0].StartTime}}
                        <span v-if="item.RestaurantMenuTypeHoursToday[0].EndTime">
                            {{' - ' + item.RestaurantMenuTypeHoursToday[0].EndTime}}
                        </span>
                      </span>
                    </div>
                  </template>
                </template>
              </div>
            </li>

          </ul>
        </div>
        <no-item title="No menu type available" v-else/>
      </b-overlay>
    </b-card>
    <b-card body-class="py-3" v-if="currentMenuTypeModel && currentMenuTypeModel.MenuTypeComment">
      <b-row class="justify-content-center">
        <b-col cols="12" lg="auto">
          <div class="p-2 text-center" style="color: #607d8b;border-bottom: 1px solid #607d8b;border-top: 1px solid #607d8b">
            {{currentMenuTypeModel.MenuTypeComment}}
          </div>
        </b-col>
      </b-row>
    </b-card>
    <create-menu-type :menu-id="edibleType" v-model="createModal" @refresh="refresh"/>
    <edit-menu-type v-model="editModal" :menu="currentMenuType" :has-category="hasCategory" @refresh="refresh"/>
    <c-modal
      v-model="duplicateModal"
      size="md"
      centered
      no-fade
      :tag="false"
      title="Duplicate Menu Confirmation"
      confirm-label="Yes, Duplicate Menu"
      cancel-label="No, Never mind"
      :progressing="duplicateLoading"
      @submit="duplicateMenu"
    >
      <template>
        Do you want to make a copy of <b>{{currentMenuTypeModel && currentMenuTypeModel.MenuType}}</b>?
      </template>
    </c-modal>
  </div>
</template>

<script>
  import CreateMenuType from "./createMenuType";
  import moment from 'moment'
  import EditMenuType from "./editMenuType";
  import NoItem from "../../../shared/noItem";
  import CModal from "../../../shared/Cmodal";
  export default {
    name: "index",
    components: {NoItem, EditMenuType, CreateMenuType, CModal},
    props: {
      items: {
        required: true,
        type: Array
      },
      edibleType: {
        required: true,
        type: [String, Number]
      },
      profile: {
        required: true
      },
      progressing: {type: Boolean, default: false},
      hasCategory: {
        type: Boolean, default: false
      }
    },
    data () {
      return {
        createModal: false,
        editModal: false,
        currentMenuType: {},
        duplicateModal: false,
        duplicateLoading: false
      }
    },
    computed: {
      currentMenuTypeModel () {
        return this.items.find(item => item.selected)
      }
    },
    methods: {
      openDuplicateModal () {
        if (!this.currentMenuTypeModel) return
        this.duplicateModal = true
      },
      duplicateMenu () {
        const model = {
          UserID: localStorage.getItem('userID'),
          RestaurantID: this.$store.state.selectedRestaurantId,
          MenuTypeID: this.currentMenuTypeModel.MenuTypeID,
          ItemType: this.edibleType
        }
        this.duplicateLoading = true
        return this.$api.getRestaurant.DuplicateMenu(model).then(res => {
          this.duplicateLoading = false
          if (res.success) {
            this.duplicateModal = false
            this.refresh()
          } else {
            this.$showError(res.message)
          }
        }).catch(() => {
          this.duplicateLoading = false
          this.$showError('error on duplicating menu')
        })
      },
      specialDate (date) {
        moment.locale('en-ca');
        if (!date) return ''
        return moment(date).format('D MMM')
      },
      selectMenuType (item) {
        this.items.forEach(each => {
          each.selected = false
        })
        item.selected = true
        this.$emit('getCategories', item)
      },
      getSelectedMenuType(menu) {
        this.currentMenuType = menu
        this.$nextTick(() => {
          this.editModal = true
        })
        
      },
      edit (item) {
        console.log(item)
      },
      changeMenuType (menuType) {
        this.$emit('refreshMenuType', menuType)
      },
      refresh () {
        this.$emit('refreshMenuType', this.edibleType)
      }
    }
  }
</script>

<style scoped lang="scss">
  .menutypes{
    li.menu-type{
      border-bottom: 2px solid #37474f;
      &:hover{
        background-color: #e5e5e5;
        border-bottom: 2px solid yellow;
        cursor: pointer;
        color: black;
      }
    }

    li.special-menu-type{
      background-color: yellow;
      border-bottom: 2px solid #37474f;
    }
    li.invisible-menu-type{
      background-image: radial-gradient(#eeeeee 3px, transparent 3px), radial-gradient(#ffffff 3px, transparent 3px);
      background-size: 20px 20px;
      background-position: 0 0, 12px 12px;
      background-color: #fff;
      /*background-color: black;*/
      /*border-bottom: 2px solid black;*/
      color: black;
    }
  }
  .activeBtn {
    background: #f5c31d !important;
    border-color: #c8ced3 !important;
    font-weight: bold;
  }
  .deactiveBtn {
    background: #fff !important;
    border-color: #c8ced3 !important;
    color: #c8ced3 !important;
    font-weight: bold;
  }
  .active-menu-type{
    background-color: #ffe0b2 !important;
    border-bottom: 2px solid orange !important;
    color: black !important;
    opacity: 0.7;
  }
</style>
